const devUsersIdsEnv = process.env.REACT_APP_DEV_USERS_IDS ?? '';
const devUsersIds = devUsersIdsEnv.split(',').filter(v => v).map(Number);

export {
  devUsersIds,
};
